var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import cn from 'classnames';
import { useMemo } from 'react';
import { useIsLoadingValue } from '../../hooks';
import { Skeleton } from '../Skeleton';
import styles from './styles.module.css';
export function SkeletonText(_a) {
    var { width, className, rowClassName, lineClassName, children, loading, lines = 3, typography = 'body-m' } = _a, restProps = __rest(_a, ["width", "className", "rowClassName", "lineClassName", "children", "loading", "lines", "typography"]);
    const lineTestId = restProps['data-test-id'] ? `${restProps['data-test-id']}_line` : undefined;
    const rows = useMemo(() => Array(lines)
        .fill(true)
        .map((_, index) => (_jsx("div", { className: cn(styles.skeletonTextRow, rowClassName), style: {
            lineHeight: `var(--size-skeleton-text-line-height-${typography})`,
        }, children: _jsx(Skeleton, { "data-test-id": lineTestId, loading: true, height: `var(--size-skeleton-text-font-size-${typography})`, borderRadius: `var(--radius-skeleton-text-${typography})`, className: cn(styles.skeletonTextLine, lineClassName) }) }, index))), [lines, rowClassName, lineTestId, typography, lineClassName]);
    const isLoading = useIsLoadingValue(loading);
    if (isLoading) {
        return (_jsx("div", Object.assign({}, restProps, { className: cn(className, styles.skeletonText), style: { width }, children: rows })));
    }
    return _jsx(_Fragment, { children: children });
}
